import styled from "styled-components";
import { PaymentMethodsContainer } from "../../health/health-payment-methods/payment-methods-style";

export const ForeignersHealthPaymentContainer = styled(PaymentMethodsContainer)``;
